import React from "react";
import AddressLocationSelector from "./addressLocation/AddressLocationSelector";
import { countryNameOf } from "./addressLocation/addressLocationData";
import "./GeoCascadeFields.css";

// Target Location (Local Selling zones): Country -> State / Province -> City
// -> ZIP / Postal code, now the strict mode of the shared
// AddressLocationSelector (same data and logic as every address form of
// Elakay). Pure selection UI: it never saves an address -- the caller
// decides what the selection is for.
//
// value: { country, countryName, stateOrProvince, stateCode, city,
//          postalCode, latitude, longitude }
// Changing a level resets every level below it; a city / ZIP is only kept
// when it exists in the data. The ZIP can also be typed first (after the
// country): its state and city are then filled in. Countries without
// geographic data fall back to free-text fields.
export const EMPTY_GEO_VALUE = {
  country: "", countryName: "", stateOrProvince: "", stateCode: "", city: "", postalCode: "", latitude: null, longitude: null,
};

const GeoCascadeFields = ({ value = EMPTY_GEO_VALUE, onChange, tr = (k, f) => f, disabled = false, idPrefix = "geo" }) => {
  const v = { ...EMPTY_GEO_VALUE, ...value };
  const location = {
    country: v.country, state: v.stateOrProvince, stateCode: v.stateCode, city: v.city,
    postalCode: v.postalCode, latitude: v.latitude, longitude: v.longitude,
  };
  const change = (next) => onChange?.({
    ...v,
    country: next.country,
    countryName: next.country === v.country && v.countryName ? v.countryName : countryNameOf(next.country),
    stateOrProvince: next.state,
    stateCode: next.stateCode,
    city: next.city,
    postalCode: next.postalCode,
    latitude: next.latitude ?? null,
    longitude: next.longitude ?? null,
  });

  return (
    <AddressLocationSelector
      strict
      value={location}
      onChange={change}
      tr={tr}
      disabled={disabled}
      idPrefix={idPrefix}
      wrapperClassName="geo-cascade"
      classNames={{ field: "geo-cascade__field", status: "geo-cascade__note" }}
    />
  );
};

export default GeoCascadeFields;
